import { useContext, useEffect, useState } from "react"
import Select from "react-select";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import SchoolContext from "../../../Context/SchoolContext";
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";
import ajaxStudentGroup from "../../../util/remote/ajaxStudentGroup";
import toast from "react-hot-toast";


const PrintFilterForm3=(props)=>{

    const [loading, setLoading] = useState(false)
    const {schoolList} = useContext(SchoolContext);
    const [school, setSchool] = useState("");
    const [schoolId, setSchoolId] = useState("");
    const [hasData, setHasData] = useState(false);
    const [localList, setLocalList] = useState([]);
    const [groupList, setGroupList] = useState(false);
    const [group, setGroup] = useState("");

    useEffect(() => {
        if (schoolId) {
            getGroups(schoolId);
        } else {
            setGroupList([]);
        }
    }, [schoolId]);

    const handleSearch = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxStudent.printAllNoPrintStudents(school, group);
        setLoading(false);
        if(server_response.status==="OK"){
            const list = server_response.details.list || [];
            props.g(list);
            setLocalList(list);
            setHasData(list.length > 0);
        }
        else{
            toast.error(server_response.message); 
            props.g(false)
            setLocalList([]);
            setHasData(false);
        } 
    }

    const handleExport = () => {
        props.h(localList);
    };

    const getGroups = async (schoolId) => {
        const server_response = await ajaxStudentGroup.fetchGroupList(schoolId);
        if (server_response.status === "OK") {
            setGroupList(server_response.details);
        }
        else {
            setGroupList([]);
        }
      };
    
      
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    {!hasData? <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>:
                    <button
                        type="button"
                        className="btn-fill-md text-light bg-success ml-2"
                        onClick={handleExport}
                        disabled={!hasData}
                    >
                        Export<i className="fas fa-file-export mg-l-15"></i>
                    </button>}
                    </>
        }
    }

    return(
        <SystemModal
            title="Export Student List"
            id="model-call-filter"
            size="md"
            footer={RenderFooter}
        >  
            
            <div className="mb-4 form-group border-1">
                <label htmlFor="">School</label>
                <Select
                onChange={(e) => { setSchool(e ? e.school_code : ""); setSchoolId(e ? e.school_id : ""); setGroup(""); }}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_code}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_code === school)
                }
              />
            </div>

            <div className="mb-4 form-group border-1">
                <label htmlFor="">Group</label>
                <Select
                      onChange={(e) => setGroup(e.group_id)}
                      getOptionLabel={(option) => option.group_name}
                      getOptionValue={(option) => option.group_id}
                      isSearchable
                      options={Array.isArray(groupList) ? groupList : []}
                      value={
                        Array.isArray(groupList) &&
                        groupList.find((value) => value.group_id === group)
                      }
                    />
            </div>
        
       
        </SystemModal>
    )
}

export default PrintFilterForm3
